/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { QuickOrderTemplateLine } from '@msdyn365-commerce-modules/retail-actions';
import { observable } from 'mobx';

/**
 * Represents a product for quick order grid.
 */
export class QuickOrderGridProduct {
    @observable
    public isSelected: boolean;

    public readonly productLine: QuickOrderTemplateLine;

    public constructor(productLine: QuickOrderTemplateLine) {
        this.productLine = productLine;
        this.isSelected = false;
    }
}
